module.exports = __webpack_public_path__ + "static/media/main.42915552.scss";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/main.scss
// module id = 223
// module chunks = 0